import { IntegerInput } from "@/overlay/components/CommonParts/CustomInput";
import type { ThresholdColor } from "@/overlay/components/CommonParts/Threshold/types";
import { ColorPickerInput } from "@/overlay/components/LayerStackWindow/LayerFormElements";
import { ConditionOptions, conditionValues } from "@/utility/conditionalExpressions";

export interface ColorThresholdProps {
  threshold: ThresholdColor;
  onThresholdChange: (data: Partial<ThresholdColor>) => void;
  onRemove: () => void;
  step?: number;
  allowDecimals?: boolean;
}

export const ColorThresholdInput = ({
  threshold,
  onRemove,
  onThresholdChange,
  step,
  allowDecimals,
}: ColorThresholdProps) => {
  return (
    <div className={"threshold-option"}>
      <span className={"material-icons"}>drag_indicator</span>
      <ColorPickerInput
        label={""}
        value={threshold.color}
        change={(color) => onThresholdChange({ color: color })}
        data-testid={"color-picker"}
        formFieldOptions={{ alignTop: true, background: false, slimPadding: true }}
      />
      <select
        value={threshold.condition}
        onChange={(event) => onThresholdChange({ condition: event.target.value as ConditionOptions })}
        data-testid={"condition-select"}
      >
        {conditionValues?.map((condition) => (
          <option key={condition} value={condition}>
            {ConditionOptions[condition]}
          </option>
        ))}
      </select>
      <IntegerInput
        value={threshold.value}
        onChange={(value) => onThresholdChange({ value })}
        step={step}
        decimals={allowDecimals || !Number.isInteger(step)}
        data-testid={"threshold-value"}
      />
      <span className="material-icons" onClick={onRemove}>
        close
      </span>
    </div>
  );
};
